import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ElectronicInvoiceInterfaceModel } from 'src/app/models/invoicing/electronic-invoice-interface.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ElectronicInvoiceInterfaceService } from 'src/app/services/invoicing/electronic-invoice-interface.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { SynchronizerElectronicInvoiceInterfaceComponent } from '../synchronizer-electronic-invoice-interface/synchronizer-electronic-invoice-interface.component';

@Component({
  selector: 'app-register-electronic-invoice-interface',
  templateUrl: './register-electronic-invoice-interface.component.html',
  styleUrls: ['./register-electronic-invoice-interface.component.scss'],
  standalone: false
})
export class RegisterElectronicInvoiceInterfaceComponent implements OnInit {
  @ViewChild('synchronizer') synchronizerComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  buttonText: string = 'Sincronizar';
  companyId: number = 0;
  componentSynchronizer = SynchronizerElectronicInvoiceInterfaceComponent;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledState: boolean = false;
  electronicInvoiceInterfaceContract: ElectronicInvoiceInterfaceModel = new ElectronicInvoiceInterfaceModel();
  electronicInvoiceInterfaceId: number = 0;
  enterpriseId: number = 0;
  finishLoadingPrint: boolean = false;
  formElectronicInvoiceInterface: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  iconState: string = "pi pi-lock-open";
  inputsForSynchronizer$ = new BehaviorSubject<any>({
    electronicInvoiceInterfaceModel: ElectronicInvoiceInterfaceModel,
    permissionUpdatable: 0,
    dataRecover: {}
  });
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listEnterprises: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Interfaz Factura Electrónica';
  outputForSynchronizer$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateText: string = 'Abierto';
  subscription: Subscription;
  titleState: string = "";
  url: string = "electronic-invoice-interface";
  userAuthenticated: UserModel = new UserModel();
  visibleState: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private electronicInvoiceInterfaceService: ElectronicInvoiceInterfaceService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    await this.validateForm(new ElectronicInvoiceInterfaceModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.electronicInvoiceInterfaceId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();

    this.subscription = this.outputForSynchronizer$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'update':
          this.handleElectronicInvoiceInterfaceNavigation('last', payload.branchId, payload.enterpriseId, null)
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
    this.subscription.unsubscribe();
  }

  async changeConsecutive() {
    const branchId = this.formElectronicInvoiceInterface.get("branchId")?.value;
    const entrepriseId = this.formElectronicInvoiceInterface.get("enterpriseId")?.value;
    let consecutive = this.formElectronicInvoiceInterface.get("consecutive")?.value;

    if (this.electronicInvoiceInterfaceContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    if (entrepriseId == null || entrepriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetElectronicInvoiceInterface(branchId, entrepriseId);
      return;
    }

    try {
      this.electronicInvoiceInterfaceContract = await firstValueFrom(this.electronicInvoiceInterfaceService.getElectronicInvoiceInterfaceByKeysAsync(branchId, entrepriseId, consecutive));
      this.electronicInvoiceInterfaceId = this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId;
      await this.validateForm(this.electronicInvoiceInterfaceContract);
    } catch (error) {
      console.error('Error al buscar la interfaz de factura electrónica de recuperación.', error);
      await this.validateForm(this.electronicInvoiceInterfaceContract);
    }
  }

  changeSelection() {
    this.electronicInvoiceInterfaceId = 0;
    const modelElectronicInvoiceInterface = new ElectronicInvoiceInterfaceModel();
    modelElectronicInvoiceInterface.branchId = this.branchId;
    modelElectronicInvoiceInterface.enterpriseId = this.enterpriseId;
    this.electronicInvoiceInterfaceContract = modelElectronicInvoiceInterface;
    this.validateForm(modelElectronicInvoiceInterface);
  }

  async openSynchronizer() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear interfaz de factura electrónica. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    if (this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId == 0) {
      this.electronicInvoiceInterfaceContract.branchId = this.branchId;
      this.electronicInvoiceInterfaceContract.enterpriseId = this.enterpriseId;
      this.location.replaceState(`/${this.url}/register`);
      this.disabledDetail, this.disabledActions = true;
      await this.validateForm(this.electronicInvoiceInterfaceContract);
      this.electronicInvoiceInterfaceId = 0;

    }

    this.inputsForSynchronizer$.next({
      electronicInvoiceInterfaceModel: this.electronicInvoiceInterfaceContract,
      permissionUpdatable: this.permissionUpdatable,
      dataRecovery: {
        listBranches: this.listBranches,
        listEnterprises: this.listEnterprises
      }
    });
    this.synchronizerComponent && this.synchronizerComponent.show();
  }

  async getAllLists() {
    try {
      const [branches, enterprises] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync())
      ]);
      this.listBranches = branches;
      this.listEnterprises = enterprises;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formElectronicInvoiceInterface.get("consecutive")?.value;
    const branchId = this.formElectronicInvoiceInterface.get("branchId")?.value;
    const enterpriseId = this.formElectronicInvoiceInterface.get("enterpriseId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }

    if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleElectronicInvoiceInterfaceNavigation(buttonClick, branchId, enterpriseId, consecutive);
  }


  getButtonText(electronicInvoiceInterfaceId: number) {
    this.buttonText = electronicInvoiceInterfaceId && electronicInvoiceInterfaceId != 0 ? 'Consultar' : 'Sincronizar'
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        validBranch = branchId;
      }
    }
    this.branchId = validBranch ?? 0;
    this.formElectronicInvoiceInterface.controls["branchId"].patchValue(validBranch);
    if (reload) {
      await this.getFirstEnterpriseByBranch(this.branchId);
      this.changeSelection();
    }
  }

  async getElectronicInvoiceInterfaceById() {
    try {
      this.electronicInvoiceInterfaceContract = await firstValueFrom(this.electronicInvoiceInterfaceService.getElectronicInvoiceInterfaceById(this.electronicInvoiceInterfaceId));
      this.electronicInvoiceInterfaceId = this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId;
      this.branchId = this.electronicInvoiceInterfaceContract.branchId;
      this.enterpriseId = this.electronicInvoiceInterfaceContract.enterpriseId;
      await this.validateForm(this.electronicInvoiceInterfaceContract);
    } catch (error) {
      console.error('Error al buscar la interfaz de factura electrónica.', error);
    }
  }

  async getEnterprise(enterpriseId: number | null, reload: boolean) {
    if (enterpriseId != null) {
      this.formElectronicInvoiceInterface.controls["enterpriseId"].patchValue(enterpriseId);
      this.enterpriseId = enterpriseId;
    }
    if (reload) {
      this.changeSelection();
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
    this.branchId = response.branchId;
    this.getBranch(response.branchId, false);
    this.companyId = response.companyId;
    this.getFirstEnterpriseByBranch(response.branchId);
  }

  async getFirstEnterpriseByBranch(branchId: number | null) {
    if (branchId != null && branchId != 0) {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      if (response) {
        this.formElectronicInvoiceInterface.controls["enterpriseId"].patchValue(response.enterpriseId);
        this.enterpriseId = response.enterpriseId;
      } else {
        this.toastHandlerService.showToast('warning', 'La sucursal no tiene empresas creadas.', 'Atención');
      }
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }

    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
    ]);

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getAllLists();

    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.ElectronicInvoiceInterface));
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`${this.url}`]);
  }

  async handleInitialState() {
    if (this.electronicInvoiceInterfaceId !== null && this.electronicInvoiceInterfaceId !== 0) {
      await this.getElectronicInvoiceInterfaceById();
    } else {
      this.openSynchronizer();
    }
  }

  private async handleElectronicInvoiceInterfaceNavigation(buttonClick: any, branchId: number, enterpriseId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<ElectronicInvoiceInterfaceModel>> = {
      first: () => firstValueFrom(this.electronicInvoiceInterfaceService.getFirstElectronicInvoiceInterfaceByKeysAsync(branchId, enterpriseId)),
      previus: () => firstValueFrom(this.electronicInvoiceInterfaceService.getPreviusElectronicInvoiceInterfaceByKeysAsync(branchId, enterpriseId, consecutive)),
      next: () => firstValueFrom(this.electronicInvoiceInterfaceService.getNextElectronicInvoiceInterfaceByKeysAsync(branchId, enterpriseId, consecutive)),
      last: () => firstValueFrom(this.electronicInvoiceInterfaceService.getLastElectronicInvoiceInterfaceByKeysAsync(branchId, enterpriseId))
    };

    const actionKey = typeof buttonClick === 'string'
      ? buttonClick
      : buttonClick.target.id;

    const action = actionMap[actionKey]
    if (!action) {
      await this.resetElectronicInvoiceInterface(branchId, enterpriseId);
      return;
    }

    try {
      const electronicInvoiceInterface = await action();
      this.electronicInvoiceInterfaceContract = electronicInvoiceInterface;
      this.electronicInvoiceInterfaceId = electronicInvoiceInterface.electronicInvoiceInterfaceId;
      await this.validateForm(electronicInvoiceInterface);
      this.location.replaceState(`/${this.url}/register/${this.electronicInvoiceInterfaceId}`);
    } catch (error) {
      console.error(`Error al buscar la interfaz de factura electrónica (${buttonClick.target.id}).`, error);
    }
  }

  async resetElectronicInvoiceInterface(branchId: number, enterpriseId: number) {
    this.electronicInvoiceInterfaceId = 0;
    this.electronicInvoiceInterfaceContract = new ElectronicInvoiceInterfaceModel();
    this.electronicInvoiceInterfaceContract.branchId = branchId;
    this.electronicInvoiceInterfaceContract.enterpriseId = enterpriseId;
    await this.validateForm(this.electronicInvoiceInterfaceContract);
  }

  async updateFormState() {
    type StateConfig = {
      severity: string;
      icon: string;
      title: string;
      text: string;
      isDisabled: boolean;
      enableConsecutive: boolean;
    };

    let config: StateConfig;
    if (this.electronicInvoiceInterfaceContract.active) {
      config = {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.electronicInvoiceInterfaceId !== 0 && this.electronicInvoiceInterfaceId !== null,
      };
    } else {
      config = {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      };
    }

    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = config.isDisabled;
      const enableConsecutive = config.enableConsecutive;

      this.disabledForm ? this.formElectronicInvoiceInterface.disable() : this.formElectronicInvoiceInterface.enable();
      const control = this.formElectronicInvoiceInterface.controls["consecutive"];
      enableConsecutive ? control.enable() : control.disable();
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formElectronicInvoiceInterface.disable());
    this.formControlStateService.setControlState(this.formElectronicInvoiceInterface, ['branchId', 'enterpriseId'], true);

  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar la interfaz de factura electrónica. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    if (this.electronicInvoiceInterfaceContract.electronicInvoiceInterfaceId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una interfaz de factura electrónica.', 'Atención');
      return false;
    }
    return true;
  }

  validateForm(electronicInvoiceInterface: ElectronicInvoiceInterfaceModel) {
    this.formElectronicInvoiceInterface = this.formBuilder.group({
      branchId: [electronicInvoiceInterface.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [electronicInvoiceInterface.enterpriseId, [Validators.required, Validators.min(1)]],
      consecutive: [electronicInvoiceInterface.consecutive, [Validators.required]],
      active: [electronicInvoiceInterface.active, []],
      dateInterface: [electronicInvoiceInterface.dateInterface ?
        this.dateConverterService.convertUtcToLocalDate(electronicInvoiceInterface.dateInterface) : null, [Validators.required]],
      observation: [electronicInvoiceInterface.observation, [Validators.maxLength(50)]]
    });
    this.updateFormState();
    this.getButtonText(electronicInvoiceInterface.electronicInvoiceInterfaceId);
  }

}
